import { TrainerMetricsInterface, UserInfoInterface } from '@elearning-platform/api-types/interfaces';

import { api } from '../api';

export const uploadUserFacsimile: (file: File) => Promise<void> = (file: File): Promise<void> => {
  const formData: FormData = new FormData();
  formData.append('facsimile', file);

  return api.post('users/profile/facsimile', formData, { customEnv: { notEncryptedRequest: true } });
};

export const downloadUserFacsimile: () => Promise<string> = (): Promise<string> => api.get(
  'users/profile/facsimile', { customEnv: { notEncryptedResponse: true } }
);

export const updateAvatar: (file: File) => Promise<void> = (file: File): Promise<void> => {
  const formData: FormData = new FormData();
  formData.append('avatar', file);

  return api.post('users/profile/avatar', formData, { customEnv: { notEncryptedRequest: true } });
};

export const removeAvatar: () => Promise<string> = (): Promise<string> => api.delete('users/profile/avatar');

export const getUserInfo: () => Promise<UserInfoInterface> = (): Promise<UserInfoInterface> => api.get('v1/users/info');

export const getTrainerMetrics: (id: number) => Promise<TrainerMetricsInterface> = (
  id: number
): Promise<TrainerMetricsInterface> => api.get(`v1/users/${id}/metrics`);
